import { call, put, takeLatest } from 'redux-saga/effects';
import { aiTransformService } from './aiTransform.service';
import {
    TRANSFORM_RICH_TEXT,
    TRANSFORM_RICH_TEXT_FAIL,
    TRANSFORM_RICH_TEXT_SUCCESS,
} from './aiTransform.type';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* transformRichText(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(
            aiTransformService.transformRichText,
            action.payload.sourceText,
            action.payload.instruction,
        );
        yield put({ type: TRANSFORM_RICH_TEXT_SUCCESS, payload: res.data });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put({
            type: TRANSFORM_RICH_TEXT_FAIL,
            payload: err?.data?.message || 'AI transform failed',
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(
            httpRequestsOnErrorsActions.appendError(
                action.type,
                err?.data?.message || 'AI transform failed',
            ),
        );
    }
}

export const watchAiTransform = function* watchAiTransformSaga() {
    yield takeLatest(TRANSFORM_RICH_TEXT, transformRichText);
};
